export const type = 'login'

const login = value => {
    return {
        type,
        payload: value
    }
}

export default login